<template>
  <div>
    <el-button
      class="mobile-btn"
      plain
      icon="el-icon-menu"
      @click="open = true"
      v-if="isMobile"
    ></el-button>

    <!-- 👇 关键：关闭默认遮罩 -->
    <el-drawer
      :visible.sync="open"
      direction="ltr"
      size="260px"
      :modal="false"
      :with-header="false"
      custom-class="mobile-drawer"
    >
      <el-menu default-active="$route.path" router @select="handleSelect">
        <el-menu-item index="/">{{ $t('nav.home') }}</el-menu-item>

        <el-submenu index="/products">
          <template slot="title">{{ $t('nav.products') }}</template>
          <el-menu-item index="/products/Solutions">{{ $t('nav.products_solutions') }}</el-menu-item>
          <el-menu-item index="/products/Devices">{{ $t('nav.products_devices') }}</el-menu-item>
          <!-- <el-menu-item index="/products/cloud">{{ $t('nav.products_cloud') }}</el-menu-item> -->
        </el-submenu>

        <el-submenu index="/news">
          <template slot="title">{{ $t('nav.news') }}</template>
          <el-menu-item index="/news/company">{{ $t('nav.news_company') }}</el-menu-item>
          <el-menu-item index="/news/industry">{{ $t('nav.news_industry') }}</el-menu-item>
          <el-menu-item index="/news/tech">{{ $t('nav.news_tech') }}</el-menu-item>
        </el-submenu>

        <el-submenu index="/service">
          <template slot="title">{{ $t('nav.service') }}</template>
          <el-menu-item index="/service/support">{{ $t('nav.service_support') }}</el-menu-item>
          <el-menu-item index="/service/downloads">{{ $t('nav.service_downloads') }}</el-menu-item>
          <el-menu-item index="/service/faq">{{ $t('nav.service_faq') }}</el-menu-item>
        </el-submenu>

        <el-submenu index="/about">
          <template slot="title">{{ $t('nav.about') }}</template>
          <el-menu-item index="/about/company">{{ $t('nav.about_company') }}</el-menu-item>
          <el-menu-item index="/about/team">{{ $t('nav.about_team') }}</el-menu-item>
        </el-submenu>

        <el-menu-item index="/contact">{{ $t('nav.contact') }}</el-menu-item>
      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'MobileDrawer',
  data() {
    return { open: false }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 800
    }
  },
  methods:{
      handleSelect() {
      // 点击菜单项后关闭抽屉
      this.open = false
    }
  },
}
</script>

<style>
/* 不要 scoped，让覆盖生效 */
.mobile-btn {
  display: none;
}
@media (max-width: 800px) {
  .mobile-btn {
    display: inline-block;
  }
}

/* ✅ Drawer 自定义样式 */
.mobile-drawer {
  z-index: 9999 !important; /* 防止其他组件遮挡 */
  background: #fff;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.15);
}
</style>
